/* eslint-disable */
// Deprecated. To be removed when reports refresh is finalized.
import * as ShowMediaModal from '@/app/store/actions';
import Dialog from '@material-ui/core/Dialog';
import Close from '@material-ui/icons/Close';
import PlayArrowOutlined from '@material-ui/icons/PlayArrowOutlined';
import makeStyles from '@material-ui/styles/makeStyles';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import OnlyMediaComponent from './OnlyMediaComponent';

const useStyles = makeStyles(() => ({
	backDrop: {
		backdropFilter: 'blur(10px)',
		backgroundColor: 'rgba(0,0,30,0.4)',
	},
}));

const MediaRenderer = ({ media, photo, video, videoThumbnail }) => {
	const [imageLoaded, setImageLoaded] = useState(false);
	const [imageError, setImageError] = useState(false);
	const [pictureLarge, setPictureLarge] = useState(null);
	const classes = useStyles();
	const dispatch = useDispatch();

	const handleImageLoad = () => {
		setImageLoaded(true);
	};

	const handleImageError = () => {
		setImageError(true);
	};

	const showMoreMedia = () => {
		dispatch(
			ShowMediaModal.openMediaDialog({
				children: <OnlyMediaComponent media={media} />,
			}),
		);
	};

	if (photo) {
		return (
			<>
				{pictureLarge ? (
					<Dialog
						BackdropProps={{
							classes: {
								root: classes.backDrop,
							},
						}}
						onClose={() => {
							setPictureLarge(null);
						}}
						open={pictureLarge}
					>
						<div className="larg_image flex flex-col">
							<div className="self-end cursor-pointer absolute profile-close" onClick={() => setPictureLarge(null)}>
								<Close />
							</div>
							<img
								onError={handleImageError}
								onLoad={handleImageLoad}
								src={pictureLarge}
								style={{ display: imageLoaded ? 'block' : 'none' }}
							/>
						</div>
					</Dialog>
				) : null}
				<img
					onClick={() => setPictureLarge(photo)}
					onError={handleImageError}
					onLoad={handleImageLoad}
					src={photo}
					style={{
						margin: '16px 0px',
						borderRadius: '11px',
						height: 203,
						width: 373,
						objectFit: 'cover',
						display: imageLoaded ? 'block' : 'none',
					}}
				/>
				{!imageLoaded && !imageError ? <div>Loading...</div> : null}
			</>
		);
	}
	if (video) {
		return (
			<video
				controls
				poster={videoThumbnail}
				src={video}
				style={{
					margin: '16px 0px',
					borderRadius: '11px',
					height: 203,
					width: 373,
					objectFit: 'cover',
				}}
			/>
		);
	}
	if (media.length === 1) {
		return (
			<>
				{pictureLarge ? (
					<Dialog
						BackdropProps={{
							classes: {
								root: classes.backDrop,
							},
						}}
						onClose={() => {
							setPictureLarge(null);
						}}
						open={pictureLarge}
					>
						<div className="larg_image flex flex-col">
							<div className="self-end cursor-pointer absolute profile-close" onClick={() => setPictureLarge(null)}>
								<Close />
							</div>
							<img
								onError={handleImageError}
								onLoad={handleImageLoad}
								src={pictureLarge}
								style={{ display: imageLoaded ? 'block' : 'none' }}
							/>
						</div>
					</Dialog>
				) : null}
				{media[0].type === 'image' ? (
					<img
						onClick={() => setPictureLarge(media[0].link)}
						onError={handleImageError}
						onLoad={handleImageLoad}
						src={media[0].link}
						style={{
							margin: '16px 0px',
							borderRadius: '11px',
							height: 203,
							width: 373,
							objectFit: 'cover',
							display: imageLoaded ? 'block' : 'none',
						}}
					/>
				) : (
					<video
						controls
						poster={media[0].thumb}
						src={media[0].link}
						style={{
							margin: '16px 0px',
							borderRadius: '11px',
							height: 203,
							width: 373,
							objectFit: 'cover',
						}}
					/>
				)}
				{!imageLoaded && !imageError ? <div>Loading...</div> : null}
			</>
		);
	}
	if (media.length === 2) {
		return (
			<>
				{pictureLarge ? (
					<Dialog
						BackdropProps={{
							classes: {
								root: classes.backDrop,
							},
						}}
						onClose={() => {
							setPictureLarge(null);
						}}
						open={pictureLarge}
					>
						<div className="larg_image flex flex-col">
							<div className="self-end cursor-pointer absolute profile-close" onClick={() => setPictureLarge(null)}>
								<Close />
							</div>
							<img
								onError={handleImageError}
								onLoad={handleImageLoad}
								src={pictureLarge}
								style={{ display: imageLoaded ? 'block' : 'none' }}
							/>
						</div>
					</Dialog>
				) : null}
				<div
					className="flex"
					style={{
						margin: '16px 0px',
						borderRadius: '11px',
						height: 203,
						width: 373,
						objectFit: 'cover',
					}}
				>
					{media.map((item, index) => {
						return (
							<>
								{item.type === 'image' ? (
									<img
										onClick={() => setPictureLarge(item.link)}
										onError={handleImageError}
										onLoad={handleImageLoad}
										src={item.link}
										style={{
											margin: '16px 0px',
											width: '50%',
											objectFit: 'cover',
											display: imageLoaded ? 'block' : 'none',
										}}
									/>
								) : (
									<video
										controls
										poster={item.thumb}
										src={item.link}
										style={{
											margin: '16px 0px',
											width: '50%',
											objectFit: 'cover',
										}}
									/>
								)}
								{!imageLoaded && !imageError ? <div>Loading...</div> : null}
							</>
						);
					})}
				</div>
			</>
		);
	}
	if (media.length > 2) {
		return (
			<>
				{pictureLarge ? (
					<Dialog
						BackdropProps={{
							classes: {
								root: classes.backDrop,
							},
						}}
						onClose={() => {
							setPictureLarge(null);
						}}
						open={pictureLarge}
					>
						<div className="larg_image flex flex-col">
							<div className="self-end cursor-pointer absolute profile-close" onClick={() => setPictureLarge(null)}>
								<Close />
							</div>
							<img
								onError={handleImageError}
								onLoad={handleImageLoad}
								src={pictureLarge}
								style={{ display: imageLoaded ? 'block' : 'none' }}
							/>
						</div>
					</Dialog>
				) : null}
				<div
					className="flex"
					style={{
						height: 200,
						width: 373,
						objectFit: 'cover',
					}}
				>
					{media[0]?.type === 'image' ? (
						<img
							onClick={() => setPictureLarge(media[0].link)}
							onError={handleImageError}
							onLoad={handleImageLoad}
							src={media[0]?.link}
							style={{
								height: '100%',
								width: 275,
								objectFit: 'cover',
								display: imageLoaded ? 'block' : 'none',
							}}
						/>
					) : (
						<video
							controls
							poster={media[0]?.thumb}
							src={media[0]?.link}
							style={{
								height: '100%',
								width: 275,
								objectFit: 'cover',
							}}
						/>
					)}
					<div className="flex flex-col">
						{media?.slice(1, 3).map((item, index) => {
							return index !== 1 ? (
								<div key={index}>
									{item?.type === 'image' ? (
										<img
											onClick={() => setPictureLarge(item.link)}
											onError={handleImageError}
											onLoad={handleImageLoad}
											src={item?.link}
											style={{
												width: 98,
												height: 100,
												objectFit: 'cover',
												display: imageLoaded ? 'block' : 'none',
											}}
										/>
									) : (
										<div className="relative" key={index}>
											<video
												controls
												poster={item?.thumb}
												src={item?.link}
												style={{
													width: 98,
													height: 100,
													objectFit: 'cover',
												}}
											/>
											<div
												className="black-cover text-white cursor-pointer"
												onClick={() => {
													showMoreMedia();
												}}
											>
												<PlayArrowOutlined />
											</div>
										</div>
									)}
									{!imageLoaded && !imageError ? <div>Loading...</div> : null}
								</div>
							) : (
								// put a black shade over the last image and show count of remaining images / videos
								<div className="relative" key={index}>
									{item?.type === 'image' ? (
										<img
											onClick={() => setPictureLarge(item.link)}
											onError={handleImageError}
											onLoad={handleImageLoad}
											src={item?.link}
											style={{
												width: 98,
												height: 100,
												objectFit: 'cover',
											}}
										/>
									) : (
										<div className="relative" key={index}>
											<video
												controls
												poster={item?.thumb}
												src={item?.link}
												style={{
													width: 98,
													height: 100,
													objectFit: 'cover',
												}}
											/>
											{media.length === 3 ? (
												<div
													className="black-cover text-white cursor-pointer"
													onClick={() => {
														showMoreMedia();
													}}
												>
													<PlayArrowOutlined />
												</div>
											) : null}
										</div>
									)}
									{media?.length > 3 ? (
										<div
											className="black-cover text-white cursor-pointer"
											onClick={() => {
												showMoreMedia();
											}}
										>
											+{media?.length - 3}
										</div>
									) : null}
								</div>
							);
						})}
					</div>
				</div>
			</>
		);
	}
	return null;
};

export default MediaRenderer;
